import { BaseState } from 'store/ducks/types';

export enum DownloadTypes {
  DownloadRequest = '@download/REQUEST',
  DownloadSuccess = '@download/SUCCESS',
  DownloadFailure = '@download/FAILURE',
}

export interface DownloadRequestPayload {
  periodStart: string;
  periodEnd?: string;
}

export interface DownloadState extends BaseState {
  readonly isSuccess: boolean;
}
